module.exports = __webpack_public_path__ + "img/精品推荐.406a4a8e.png";